// extracted by mini-css-extract-plugin
export default {"custom_tr":"helpers_custom_tr__PQfK6","orange":"helpers_orange__xFDtJ","green":"helpers_green__9vBQZ","blue":"helpers_blue__tdlvi"};